import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

// shared
import RootShared from '../../../../modules/root/main';

// local
import Nav from '../../modules/header/nav';
import Top from '../../modules/header/top';
import Footer from '../../modules/footer/main';

import { enum as affiliateLevels } from '../../../../../../enums/affiliate-levels';

const forbiddenPagesForRegisteredLevel = [
	'/statistics',
	'/offers',
	'/news',
	'/spaces',
	'/tools',
	'/finances',
	'/campaigns',
	'/dashboard',
	'/user-api',
	'/discounts',
	'/master-account',
	'/affiliates'
];

const forbiddenPagesForRegisteredLevelWithFilledSurvey = [
	...forbiddenPagesForRegisteredLevel,
	'/survey'
];

const forbiddenPagesForRegisteredLevelWithoutFilledSurvey = [
	...forbiddenPagesForRegisteredLevel,
	'/manager'
];

const RootLayoutDecorator = (RootComponent, Layout) => {
	return class Decorated extends React.Component {
		render() {
			return <RootComponent {...this.props} layout={Layout} />;
		}
	};
};

const Layout = props => {
	const hasAvailableOffers = props.userData.general.available_offers &&
		props.userData.general.available_offers.length;
	if (props.userData.general.level === affiliateLevels.registered && !hasAvailableOffers) {
		if (props.userData.general.survey) {
			if (forbiddenPagesForRegisteredLevelWithFilledSurvey
				.some(forbiddenPage => props.location.pathname.includes(forbiddenPage))) {
				browserHistory.push('/manager');
			}
		} else if (forbiddenPagesForRegisteredLevelWithoutFilledSurvey
			.some(forbiddenPage => props.location.pathname.includes(forbiddenPage))) {
			browserHistory.push('/survey');
		}
	} else if (['/manager', '/survey'].some(page => props.location.pathname.includes(page))) {
		browserHistory.push('/');
	}
	return (
		<div className="dashboard-layout">
			<Top intl={props.intl}
				logout={props.logout}
				refetchAll={props.refetchAll}
				loginWithAdmin={props.loginWithAdmin}
				saveInLocalStorage={props.saveInLocalStorage} />
			<Nav
				unreadMsgs={props.userData.unreadMsgs}
				location={props.location}
				user={props.userData}
				intl={props.intl}
				userData={props.userData} />
			<div className="dashboard-layout__content">
				{props.children}
			</div>
			<Footer intl={props.intl} />
		</div>
	);
};

Layout.propTypes = {
	children: PropTypes.element,
	intl: PropTypes.func,
	logout: PropTypes.func,
	refetchAll: PropTypes.func,
	saveInLocalStorage: PropTypes.func,
	userData: PropTypes.object,
	loginWithAdmin: PropTypes.func,
	location: PropTypes.object
};

export default RootLayoutDecorator(RootShared, Layout);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/root/main.js